import { faDot } from '@awesome.me/kit-4a6bf60416/icons/classic/solid';

import { ContentDate } from '@/components/page-sections/content-date';
import { Badge } from '@/components/ui/badge';
import { ContentContainer } from '@/components/ui/content-container';
import { Icon } from '@/components/ui/icon';
import { Heading2, Heading3, Paragraph } from '@/components/ui/typography';
import { formatProfileNames, normalizeProfiles } from '../../profile-list';
import type { BlogWidgetProps } from '../definition';

export function ListVariant({ title, blogs }: BlogWidgetProps) {
  if (blogs.length === 0) return null;

  return (
    <ContentContainer>
      {title && (
        <div className="mb-2 border-b border-border pb-4">
          <Heading2>{title}</Heading2>
        </div>
      )}

      <div className="flex flex-col gap-0">
        {blogs.map((blog, index) => {
          const authors = normalizeProfiles(blog.authors);
          const authorLabel = formatProfileNames(authors);

          return (
            <article
              key={blog.id || index}
              className="group/blog-item flex gap-6 border-b border-border py-8 last:border-b-0"
            >
              <div className="flex-1">
                {blog.title && (
                  <Heading3 className="mb-1 text-xl group-hover/blog-item:text-primary transition-colors line-clamp-1">
                    {blog.title}
                  </Heading3>
                )}
                {blog.summary && (
                  <Paragraph className="mb-4 text-muted-foreground line-clamp-2 leading-tight">
                    {blog.summary}
                  </Paragraph>
                )}
                {blog.topics && blog.topics.length > 0 && (
                  <div className="mb-4 flex flex-wrap items-center gap-2">
                    {blog.topics.map((topic) => (
                      <Badge
                        key={topic.id || topic.name}
                        size="sm"
                        colorScheme="primary"
                        variant="solid"
                      >
                        {topic.name}
                      </Badge>
                    ))}
                  </div>
                )}
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  {authorLabel && <span>{authorLabel}</span>}
                  {blog.publishedAt && authorLabel && (
                    <Icon icon={faDot} className="size-1 text-muted-foreground" />
                  )}
                  {blog.publishedAt && <ContentDate value={blog.publishedAt} />}
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </ContentContainer>
  );
}
